import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dismissable--container",
  ref: "container",
  "data-cy": "dismissable-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.dismissed)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("i", {
          class: _normalizeClass(["pre inline-icon", `inline-icon--${_ctx.icon}`])
        }, null, 2),
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createElementVNode("i", null, _toDisplayString(_ctx.label), 1)
        ], true),
        _createElementVNode("div", {
          class: "dismiss-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
        }, _toDisplayString(_ctx.dismissLabel), 1)
      ], 512))
    : _createCommentVNode("", true)
}